/**
 * Tab ids on the Procurement dashboard. `?tab=` links and the server's record-link default name
 * these same ids, so a renamed tab is renamed there too.
 */
export const TOP_TABS = {
    PROCUREMENT: 'procurement',
    CONTRACT_MANAGEMENT: 'contract-management',
};

export const PROCUREMENT_TABS = {
    DASHBOARD: 'procurement---dashboard',
    OVERVIEW: 'procurement---overview',
    PLAN: 'procurement---plan',
    GANTT_CHART: 'procurement---gantt-chart',
    APPROVALS: 'procurement---approvals',
    PURCHASE_REQUISITIONS: 'procurement---purchase-requisitions',
    PURCHASE_ORDERS: 'procurement---purchase-orders',
    POLICY: 'procurement---policy',
    CATEGORY: 'procurement---category',
    SETUP: 'procurement---setup',
};

export const CONTRACT_MANAGEMENT_TABS = {
    DASHBOARD: 'contract-management---dashboard',
    SUPPLIERS: 'contract-management---suppliers',
    EXPENDITURE_CONTRACTS: 'contract-management---expenditure-contracts',
    WORKFORCE_CONTRACTS: 'contract-management---workforce-contracts',
    REVENUE_CONTRACTS: 'contract-management---revenue-contracts',
};

/**
 * The tab one tab set opens on: the requested id when it is one of this set's own visible, enabled
 * tabs, otherwise the set's default. The requested id is page-wide and may name a tab in another
 * set, or one hidden for this user; handed to `Tabs` as the controlled value, it would match no
 * panel and leave the set blank.
 */
export const initialTabId = (tabs, requestedId, defaultId) =>
    tabs.some((tab) => tab.id === requestedId && !tab.hidden && !tab.disabled) ? requestedId : defaultId;
